import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';

/**
 * Deletes a member's work schedule override (member reverts to the tenant
 * default). On success, invalidates that member's query and the overrides list.
 */
export function useDeleteMemberWorkSchedule() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (userId: string) => workSchedulesService.removeMember(userId),
    onSuccess: (_data, userId) => {
      queryClient.invalidateQueries({ queryKey: WORK_SCHEDULES_KEYS.member(orgId, userId) });
      queryClient.invalidateQueries({ queryKey: WORK_SCHEDULES_KEYS.members(orgId) });
    },
  });
}
